import { EventInteractions } from '@eventbrite/ads';
import { FormattedEvent } from '@eventbrite/event-renderer';
import React, { FunctionComponent } from 'react';
import AdRectangleEventCard from '../../../../../../components/AdRectangleEventCard/AdRectangleEventCard';
import PromotedEventStack from '../../../../../../components/PromotedEventStack/PromotedEventStack';
import { SearchResultPanelContentEventCardList } from '../SearchResultPanelContentEventCardList';

type EbAdsSearchResultVariantProps = {
    promotedEvents: FormattedEvent[];
    baselineEvents: FormattedEvent[];
    locale: string;
    getTrackingContext: (data: any) => any;
    onRemoveEvent: (eventId: string) => void;
    isAuthenticated?: boolean;
};

export const EbAdsSearchResultVariant: FunctionComponent<
    EbAdsSearchResultVariantProps
> = ({
    promotedEvents,
    baselineEvents,
    locale,
    getTrackingContext,
    onRemoveEvent,
    isAuthenticated = false,
}) => {
    const [firstPromotedEvent, ...remainingPromotedEvents] = promotedEvents;

    return (
        <>
            {/* Single promoted event at top */}
            <AdRectangleEventCard
                event={firstPromotedEvent}
                locale={locale}
                matchImageBackgroundColor={true}
                onRemoveEvent={onRemoveEvent}
                getTrackingContext={getTrackingContext}
                isAuthenticated={isAuthenticated}
                affCode="ebdssbdestsearch"
                statsigLocationString={getTrackingContext({
                    id: firstPromotedEvent.id,
                    action: EventInteractions.Impression,
                    event: firstPromotedEvent,
                })}
                statsigMetadata={{ searchRank: '1', searchPage: '1' }}
            />
            {/* First 2 organic events */}
            <SearchResultPanelContentEventCardList
                events={baselineEvents.slice(0, 2)}
                locale={locale}
                getTrackingContext={getTrackingContext}
                onRemoveEvent={onRemoveEvent}
            />
            {/* Promoted stack with remaining promoted events (up to 5) */}
            {remainingPromotedEvents.length > 0 && (
                <PromotedEventStack
                    events={remainingPromotedEvents.slice(0, 5)}
                    locale={locale}
                    onRemoveEvent={onRemoveEvent}
                    getTrackingContext={getTrackingContext}
                />
            )}
            {/* Remaining organic events */}
            <SearchResultPanelContentEventCardList
                events={baselineEvents.slice(2)}
                locale={locale}
                getTrackingContext={getTrackingContext}
                onRemoveEvent={onRemoveEvent}
            />
        </>
    );
};
